import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { useEffect } from "react";
import CalculatorCard from "../../components/cards/CalculatorCard";
import Footer from "../../components/footer";
import Header from "../../components/header";
import Loader from "../../components/loader";
import { useTranslate } from "../../context/TranslationContext";
import { useGetContentQuery } from "../../redux/Apis/Content";
import { useStaticData } from "../../utils/data";
import { setMetaTags } from "../../utils/helper";

const FitnessTest = () => {
  const { FITNESSTEST } = useStaticData();
  const { t } = useTranslate("footer");

  const { data: testVideos, isLoading: isTestVideosLoading } =
    useGetContentQuery({
      search: "fitness_tests",
    });

  useEffect(() => {
    setMetaTags(
      "Traineego | Buy or Create Automated Courses & Tracks for Fitness & Wellness",
      "Create, manage, and sell your own courses and tracks, or buy high-quality content. Empower your career through automation and passive income today!",
    );
  }, []);

  if (isTestVideosLoading) {
    return (
      <>
        <Header />
        <Loader loading={true} />
      </>
    );
  }

  return (
    <>
      <Header />
      <section className="banner" style={{ textAlign: "left" }}>
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h2 className="text-uppercase">{t("fitnessTest")}</h2>
            </div>
            {FITNESSTEST.map((item) => (
              <div className="col-lg-4 col-md-6 my-3">
                <CalculatorCard data={item} content={testVideos} />
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default FitnessTest;
